import {
  FORM_INPUT_CLASS_NAME,
  FORM_TEXTAREA_CLASS_NAME,
} from "@/components/Forms/form-control-styles";

/** Shared treatment for forms opened from the new provider profile.
 * The compound dialog selectors take precedence over legacy global sizing
 * rules, including their mobile width and scrolling overrides. */
export const PROFILE_FORM_STYLES = {
  dialog:
    "flex flex-col gap-0 rounded-[2rem] border-slate-200 bg-slate-50 p-0 text-slate-900 shadow-xl sm:rounded-[2rem] [&.dialog-content]:max-h-[85dvh] [&.dialog-content]:w-[calc(100vw-2rem)] sm:[&.dialog-content]:max-w-2xl [&.dialog-content]:overflow-hidden [&>button]:right-5 [&>button]:top-6 [&>button]:rounded-xl [&>button]:p-1 [&>button]:text-slate-400 [&>button]:hover:bg-slate-100 [&>button]:hover:text-slate-700 [&>button]:focus:ring-ring",
  header:
    "shrink-0 space-y-0 border-b border-slate-200 bg-white px-6 py-6 pr-16 text-left sm:px-8 sm:pr-16",
  icon: "flex size-11 shrink-0 items-center justify-center rounded-2xl bg-primary/5 text-primary",
  eyebrow: "text-[10px] font-bold uppercase tracking-[0.16em] text-primary",
  title: "text-2xl font-bold leading-tight tracking-tight text-slate-900",
  description: "text-sm leading-relaxed text-slate-500",
  body: "min-h-0 flex-1 space-y-6 overflow-y-auto overscroll-contain p-6 sm:p-8",
  section:
    "min-w-0 space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6",
  sectionHeading:
    "text-[10px] font-bold uppercase tracking-[0.16em] text-slate-400",
  label: "text-xs font-semibold leading-relaxed text-slate-700",
  control: `${FORM_INPUT_CLASS_NAME} min-w-0`,
  textarea: FORM_TEXTAREA_CLASS_NAME,
  footer:
    "mt-0 flex shrink-0 flex-col-reverse gap-3 border-t border-slate-200 bg-white px-6 py-4 sm:flex-row sm:items-center sm:justify-end sm:space-x-0 sm:px-8",
  primaryButton:
    "h-12 rounded-xl bg-primary px-5 text-sm font-semibold text-primary-foreground shadow-sm hover:bg-primary/90 focus-visible:ring-primary",
  secondaryButton:
    "h-12 rounded-xl border-slate-400 bg-white px-5 text-sm font-semibold text-slate-600 shadow-none hover:bg-slate-50 hover:text-slate-900 focus-visible:ring-primary",
  dangerButton:
    "h-12 rounded-xl bg-red-600 px-5 text-sm font-semibold text-white hover:bg-red-700 focus-visible:ring-red-500",
  error:
    "rounded-xl border border-red-100 bg-red-50 px-4 py-3 text-sm leading-relaxed text-red-700",
  confirmation:
    "max-h-[85dvh] w-[calc(100vw-2rem)] overflow-y-auto rounded-[2rem] border-slate-200 bg-white p-6 shadow-xl sm:max-w-md sm:rounded-[2rem] sm:p-8",
} as const;
